import { HelpArticleId } from '@business/entities/helpArticle';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { CompanyId } from '@business/entities/companies';

export class HelpArticlePageBloc extends BaseBloc {
  private readonly helpArticleBloc = resolve(Blocs.helpArticle);

  constructor(private readonly HelpArticleId: HelpArticleId) {
    super();
  }

  loading = new LoadingState();

  readonly helpArticle$ = this.helpArticleBloc.selectHelpArticle(this.HelpArticleId);

  onInit() {
    return this.helpArticleBloc.fetchHelpArticle(this.HelpArticleId).pipe(this.loading.run());
  }
}
